import { SupportAgentView } from '@/components/templates/SupportAgentView'

import { useSupportAgentPage } from './useSupportAgentPage'

export const SupportAgentPage = () => <SupportAgentView {...useSupportAgentPage()} />
